var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPodcastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{clip-path:url(#SVGID_4_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,27.3076172c-5.5136719,0-10-4.4863281-10-10c0-0.5522461,0.4472656-1,1-1s1,0.4477539,1,1    c0,4.4111328,3.5888672,8,8,8s8-3.5888672,8-8c0-0.5522461,0.4472656-1,1-1s1,0.4477539,1,1    C26,22.8212891,21.5136719,27.3076172,16,27.3076172z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,24c-3.3085938,0-6-2.6914063-6-6V6c0-3.3085938,2.6914063-6,6-6s6,2.6914063,6,6v12    C22,21.3085938,19.3085938,24,16,24z M16,2c-2.2060547,0-4,1.7944336-4,4v12c0,2.2060547,1.7939453,4,4,4s4-1.7939453,4-4V6    C20,3.7944336,18.2060547,2,16,2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,32H11c-0.5527344,0-1-0.4472656-1-1s0.4472656-1,1-1h10c0.5527344,0,1,0.4472656,1,1S21.5527344,32,21,32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,32c-0.5527344,0-1-0.4472656-1-1v-4.6923828c0-0.5527344,0.4472656-1,1-1s1,0.4472656,1,1V31    C17,31.5527344,16.5527344,32,16,32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,8.9375h-3.2460938c-0.5527344,0-1-0.4477539-1-1s0.4472656-1,1-1H21c0.5527344,0,1,0.4477539,1,1     S21.5527344,8.9375,21,8.9375z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,13h-3.2460938c-0.5527344,0-1-0.4477539-1-1s0.4472656-1,1-1H21c0.5527344,0,1,0.4477539,1,1S21.5527344,13,21,13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,17.0625h-3.2460938c-0.5527344,0-1-0.4477539-1-1s0.4472656-1,1-1H21c0.5527344,0,1,0.4477539,1,1     S21.5527344,17.0625,21,17.0625z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.2460938,8.9375H11c-0.5527344,0-1-0.4477539-1-1s0.4472656-1,1-1h3.2460938c0.5527344,0,1,0.4477539,1,1     S14.7988281,8.9375,14.2460938,8.9375z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.2460938,13H11c-0.5527344,0-1-0.4477539-1-1s0.4472656-1,1-1h3.2460938c0.5527344,0,1,0.4477539,1,1     S14.7988281,13,14.2460938,13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.2460938,17.0625H11c-0.5527344,0-1-0.4477539-1-1s0.4472656-1,1-1h3.2460938c0.5527344,0,1,0.4477539,1,1     S14.7988281,17.0625,14.2460938,17.0625z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcastIcon);
export default __webpack_public_path__ + "static/media/podcast_icon.28b54b42685d57c40f866a5fccd3f9d5.svg";
export { ForwardRef as ReactComponent };